import { singleRequestServiceFactory } from 'rest/request/singleRequestServiceFactory';
import { incidentViewportEndpoint } from '../endpoints/endpoints';

export const incidentViewportRest = singleRequestServiceFactory(incidentViewportEndpoint);



// WEBPACK FOOTER //
// ./services/rest/incidentViewport.js